import { environ } from "@ihr-radioedit/sdk-utils/lib";
import axios from "axios";
import { isLeft } from "fp-ts/lib/Either";
import { ForecastList, ForecastListResolver, WeatherCurrent, WeatherCurrentResolver } from "../decoders/Weather.types";
import { getPaths } from "../lib/io-ts-validator";
import { logger } from "../lib/logging";

const log = logger.getChild("Weather");

interface WeatherQuery {
    baseUri: string;
    lat: string;
    lon: string;
    forecast?: number;
    apiKey: string;
}

export const getCurrentWeather = async ({ lat, lon, baseUri, apiKey }: WeatherQuery) => {
    const params = new URLSearchParams();
    params.set("language", "en-US");
    params.set("units", "e");
    params.set("apiKey", apiKey);

    const response = await axios.get<WeatherCurrent>(
        `${baseUri}/${lat}/${lon}/observations/current.json` + `?${params.toString()}`,
        {
            timeout: parseInt(environ.get("REQUEST_TIMEOUT", "0"), 10),
        },
    );
    const data = WeatherCurrentResolver.decode(response.data);
    if (isLeft(data)) {
        log.debug("Weather decode errors:", JSON.stringify(getPaths(data)));
        throw new Error("Could not decode API response");
    }

    return data.right;
};

export const getForecastWeather = async ({ lat, lon, baseUri, forecast, apiKey }: WeatherQuery) => {
    const params = new URLSearchParams();
    params.set("language", "en-US");
    params.set("units", "e");
    params.set("apiKey", apiKey);

    const response = await axios.get<ForecastList>(
        `${baseUri}/${lat}/${lon}/forecast/daily/${forecast}day.json` + `?${params.toString()}`,
        {
            timeout: parseInt(environ.get("REQUEST_TIMEOUT", "0"), 10),
        },
    );
    const data = ForecastListResolver.decode(response.data);
    if (isLeft(data)) {
        log.debug(forecast + " Days Weather Forecast decode errors:", JSON.stringify(getPaths(data), null, 4));
        throw new Error("Could not decode API response");
    }
    return data.right;
};
